<template>
  <div
    v-if="showDeliveryFee"
    class="my-4 rounded-lg border border-orange-200 bg-orange-50 p-4 dark:border-orange-800 dark:bg-orange-900/20"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <svg
          class="h-5 w-5 text-orange-600 dark:text-orange-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4-2a2 2 0 104 0m6 2a2 2 0 104 0m-6-2a2 2 0 104 0"
          />
        </svg>
        <div>
          <h5 class="text-sm font-medium text-orange-900 dark:text-orange-100">
            Costo de Envío
          </h5>
          <p class="text-xs text-orange-700 dark:text-orange-300">
            Calculado según reglas configuradas
          </p>
        </div>
      </div>
      <p class="text-lg font-bold text-orange-900 dark:text-orange-100">
        ${{ normalizedDeliveryFee.toFixed(2) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  orderType?: string;
  deliveryFee?: number;
}

const props = defineProps<Props>();

const normalizedDeliveryFee = computed(() => props.deliveryFee || 0);
const showDeliveryFee = computed(() => props.orderType === 'Delivery' && normalizedDeliveryFee.value > 0);
</script>
